import { ActivatedRoute } from '@angular/router';
import { AfterViewInit, Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-idin-verification-issuer-response-page',
  templateUrl: './idin-verification-issuer-response-page.component.html',
  styleUrls: ['./idin-verification-issuer-response-page.component.css'],
})
export class IdinVerificationIssuerResponsePageComponent
  implements OnInit, AfterViewInit {
  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    localStorage.setItem(
      'trxid',
      this.activatedRoute.snapshot.queryParamMap.get('trxid')
    );
    localStorage.setItem(
      'ec',
      this.activatedRoute.snapshot.queryParamMap.get('ec')
    );

    localStorage.setItem(
      'status',
      this.activatedRoute.snapshot.queryParamMap.get('status')
      );
    window.close();
  }
}
